import { differenceInCalendarDays } from 'date-fns'
import type { Matcher } from 'react-day-picker'

export type SelectionRangeModifiers = {
  selEdge?: Matcher | Matcher[]
  selMiddle?: Matcher | Matcher[]
}

/**
 * Range highlight for check-in / check-out edges and intermediate nights.
 * Cross-month stays (e.g. 29 Jul → 4 Aug) keep middle nights via `{ after, before }`.
 */
export function buildSelectionRangeModifiers(
  from: Date | null,
  to: Date | null,
): SelectionRangeModifiers {
  if (from === null) {
    return {}
  }
  if (to === null) {
    return { selEdge: [from] }
  }
  const result: SelectionRangeModifiers = { selEdge: [from, to] }
  if (differenceInCalendarDays(to, from) > 1) {
    result.selMiddle = { after: from, before: to }
  }
  return result
}
